import EfLink from '@elem/ui/ef-link';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function GuideLink() {
    const { t } = useLang('outdoorrecreation');

    return (
        <div className={styles.GuideLink}>
            <EfLink href={'https://www.facebook.com/share/g/1UUqHDiLpb/?mibextid=wwXIfr'} className="inner-link">
                {t('secM_button')}
            </EfLink>
        </div>
    );
}
